import React, { Fragment, useState } from 'react';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { useStores } from '../../hooks/use-stores';

import { Box, Typography, Button, makeStyles, Divider } from '@material-ui/core';
import CartItem from '../../components/Cart/CartItem';
import DeliveryModal from '../../components/Cart/DeliveryModal';
import NotificationModal from '../../components/NotificationModal';

const Cart = observer(() => {
    const classes = useStyles();
    const { CartStore: store } = useStores();
    const [openDeliveryModal, setOpenDeliveryModal] = useState(false);

    // Effects
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, []);

    // Renders
    const renderEmptyCart = () => {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight={300}>
                <Box mb={4}>
                    <Typography variant="h5">Ваша корзина пуста</Typography>
                </Box>
                <Link to="/catalog">
                    <Button variant="outlined" color="primary" size="small">
                        Перейти к каталогу
                    </Button>
                </Link>
            </Box>
        );
    };

    const renderCart = () => {
        return (
            <Box className={classes.root}>
                <Box mb={5}>
                    {store.cart.map((order, index) => (
                        <Fragment key={order.id}>
                            <CartItem order={order} />
                            {store.cart.length !== index + 1 && (
                                <Box my={{ xxs: 4, md: 6 }}>
                                    <Divider />
                                </Box>
                            )}
                        </Fragment>
                    ))}
                </Box>

                <Box mt={10} mb={4}>
                    <Divider />
                </Box>

                <Box display="flex" flexDirection="column">
                    <Box textAlign="right">
                        <Button variant="outlined" color="primary" onClick={() => setOpenDeliveryModal(true)}>
                            Перейти к доставке
                        </Button>
                    </Box>
                </Box>
            </Box>
        );
    };

    // Renders
    return (
        <>
            {!store.cart?.length ? renderEmptyCart() : renderCart()}

            <DeliveryModal open={openDeliveryModal} onClose={() => setOpenDeliveryModal(false)} />
            <NotificationModal
                title="Ваша заявка успешно отправлена!"
                message="В течение 15 мин с Вами свяжется менеджер для уточнения деталей заказа"
                open={store.success}
                withoutCloseBtn
            />
        </>
    );
});

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(5, 4),
        marginBottom: theme.spacing(10),
        backgroundColor: '#fff',
        boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.1)',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(3, 3),
        },
    },
}));

export default Cart;
